import { StatusMessage } from "../types/types";

export const statusMessagesMapping: Record<StatusMessage, string> = {
  INVALID_ACCOUNT: "CUENTA/ TARJETA INVÁLIDA",
  INVALID_AMOUNT: "MONTO DE LA TRANSACCIÓN INVÁLIDO",
  CUSTOMER_CANCELLATION: "CANCELADO POR EL CLIENTE",
  BANK_NOT_AVAILABLE: "ERROR EN EL BANCO",
  PAYMENT_METHOD_UNAVAILABLE: "ERROR EN EL MEDIO DE PAGO",
  DOCUMENT_ACCOUNT_MISMATCH: "DISCREPANCIA ENTRE LA CUENTA Y EL DOCUMENTO",
  EXPIRED: "TIEMPO DE PAGO EXPIRADO",
  ACCOUNT_LIMIT_REACHED: "TOPES DE CUENTA",
  AUTHENTICATION_FAILED: "AUTENTICACIÓN FALLIDA",
  DECLINED_BY_BANK: "RECHAZADO POR EL BANCO",
  NOT_ENOUGH_FUNDS: "FONDOS INSUFICIENTES",
  ACCOUNT_BLOCKED_OR_INACTIVE: "CUENTA/ TARJETA BLOQUEADA O INACTIVA",
  DECLINED_FOR_SECURITY: "RECHAZO POR SEGURIDAD",
  DUPLICATE_RECORD: "TRANSACCIÓN SIMULTÁNEA EN CURSO",
  UNSUPPORTED_CARD_FRANCHISE: "FRANQUICIA DE TARJETA INVÁLIDA",
  TOO_MANY_ATTEMPTS: "DEMASIADOS INTENTOS",
  ACCOUNT_EMBARGOED: "ERROR INESPERADO. CONTÁCTANOS PARA MAYOR INFORMACIÓN",
  ERROR: "ERROR",
};
